

mmit = {
	init: function initialize(){
		// disable search field on page load
		$('.search-table').prop('disabled', 'disabled');
		mmit.cE();
		mmit.eL();
		// Build the state selector
		mmit.buildStateSelector();
	},
	cE: function cacheElements(){
		// MMIT Table
		mmit.mmitTable = $('#data-data');
		// data state selector
		mmit.mmitStateSelector = $('#select-state');
		// region selector
		mmit.mmitRegionSelector = $('#select-region');
		// data plan selector
		mmit.mmitPlanSelector = $('#select-plan');
		// data table first column header
		mmit.mmitFirstCol = $('#firstCol');
		//  Search box for table
		mmit.mmitSearchTable = $('.search');
		// Table container
		mmit.mmitTableContainer = $('.data-table-wrapper');
		// Object that blocks table until user selects state and plan
		mmit.mmitBlocker = $('.table-blocker');
		// footnote
		mmit.mmitFootnote = $('.footnote');
		// MMIT Object
		mmit.mmit = {};
		// Array to hold MMIT data
		mmit.mmit.dataArray = [];
		// Object that holds the data to be read for MMIT Data
		mmit.mmit.dataObject = {};
		// Current State
		mmit.mmit.currentState = '';
		// Current Plan Type
		mmit.mmit.currentPlan = 'select';
		// Current Region
		mmit.mmit.currentRegion = 'select';
		// If current region is not blank this value will be true
		mmit.mmit.currentRegionSelected = false;
		//  variable for the table being created by datatables
		mmit.mmit.dataTableObj;
		// variable to show if data is already populated
		mmit.mmit.dataShown = false;

		// regex to remove spaces and returns from mobile view of col.title
		mmit.regex = /[\n]\t{4,}/g;
	},
	eL: function eventListeners(){


		// Change listener for "State Selector"
		mmit.mmitStateSelector.on('change', function(e) {
			e.preventDefault();
			mmit.mmit.currentState = e.target.value;
			if (mmit.mmit.currentState !== 'select'){
				// clear current regions
				mmit.mmitRegionSelector.empty();
				mmit.mmit.currentRegion = '';
				mmit.mmit.currentRegionSelected = false;
				mmit.mmitRegionSelector.addClass('region-selected');
				mmit.mmitRegionSelector.append('<option value="select">Select Region</option>');

				if (!mmit.mmit.dataShown){
					mmit.getMMITData(true);
				} else {
					mmit.getMMITData(false);
				}

			}
			if (mmit.mmit.currentState === 'select' || mmit.mmit.currentPlan === 'select') {
				mmit.mmitRegionSelector.removeClass('region-selected');
				mmit.hideTable();
			} else {
				mmit.showTable();
			}
		});

		// Change listener for "Region" selector
		mmit.mmitRegionSelector.on('change', function(e) {
			mmit.mmit.currentRegion = e.target.value;
			if (mmit.mmit.currentRegion !== 'select'){
				mmit.mmitRegionSelector.addClass('region-selected');
			} else {
				mmit.mmitRegionSelector.removeClass('region-selected');
			}
			if (mmit.mmit.currentState === 'select' || mmit.mmit.currentPlan === 'select') {
				mmit.mmitRegionSelector.removeClass('region-selected');
				mmit.hideTable();
			} else {
				mmit.redrawTable(mmit.returnMMITFilteredData(mmit.mmit.currentState, mmit.mmit.currentPlan, mmit.mmit.currentRegion));
				mmit.showTable();
			}
		});
		// Change listener for "Plan Type Selector"
		mmit.mmitPlanSelector.on('change', function(e) {
			mmit.mmit.currentPlan = e.target.value;
			if (mmit.mmit.currentPlan === 'select' || mmit.mmit.currentState === '') {
				mmit.hideTable();
			} else {
				mmit.redrawTable(mmit.returnMMITFilteredData(mmit.mmit.currentState, mmit.mmit.currentPlan, mmit.mmit.currentRegion));
				mmit.showTable();
			}
		});

		// Change listener for "Search" box
		mmit.mmitSearchTable.on('keypress.DT keyup.DT search.DT paste.DT cut.DT', function(e){
			var code = e.keyCode || e.which;
			if (code === 13){
				mmit.mmitSearchTable.find('.search-table').blur();
				return false;
			}
			mmit.mmit.dataTableObj.search(e.target.value).draw();
		})

		// resize listener for window so the data table is recalculated/redrawn
		$(window).on('resize', function(){
			isi.checkHeight();
		});
	},
	getMMITData: function(load){
		var currState = mmit.mmit.currentState;
		$.ajax({
			method: 'GET',
			url: 'https://mmit.livalohcp.com/json/'+currState+'.json',
			dataType: 'json',
			success: function(mmitdata) {
				//  Populate dataObject with dataByState object
				mmit.mmit.dataObject = mmitdata;
				// Call the createDataTable function with the object returned from the returnMMITFilteredData function
				mmit.buildRegionSelector(mmit.mmit.currentState);
				if (load && !mmit.mmit.dataShown){
					mmit.createDataTable(mmit.mmit.dataObject['Plans']);
					mmit.mmit.dataShown = true;
				} else {
					mmit.redrawTable(mmit.returnMMITFilteredData(mmit.mmit.currentState, mmit.mmit.currentPlan, mmit.mmit.currentRegion));
				}
			},
			error: function(err) {
				console.warn('Error:\n', err);
			}
		});
	},

	returnMMITFilteredData: function(state, planType, region){
		var dataLength;
		var stateDataArray = mmit.mmit.dataObject;
		// if the state value is blank or 'select',  we need to set dataLength to 0 for page load so an error isn't thrown.
		if (state === '' || state === 'select') {
			dataLength = 0;
		} else {
			dataLength = stateDataArray['Plans'].length;
		}
		// Get the plan types we need to look for based on what is selected from the plans drop down
		var ptArray = mmit.returnPlanType(planType);
		var tempDataArray = [];
		// Check each data item to see if its 'Channel' matches the channel we are looking for within the ptArray and if it does match then we push it to the tempDataArray
		for (var i = 0; i < dataLength; i++) {
			if (ptArray.indexOf(stateDataArray['Plans'][i].channel) !== -1) {
				if (region && region !== 'select'){
					if (stateDataArray['Plans'][i]['regions'][region]){
						if (stateDataArray['Plans'][i].allLives) {
							stateDataArray['Plans'][i].lives = stateDataArray['Plans'][i]['regions'][region];
						} else {
							stateDataArray['Plans'][i].allLives = stateDataArray['Plans'][i]['lives'];
							stateDataArray['Plans'][i].lives = stateDataArray['Plans'][i]['regions'][region];
						}
						tempDataArray.push(stateDataArray['Plans'][i]);
					}
				} else {
					if (stateDataArray['Plans'][i].allLives){
						stateDataArray['Plans'][i].lives = stateDataArray['Plans'][i].allLives;
					}
					tempDataArray.push(stateDataArray['Plans'][i]);
				}
			}
		}
		// if the PlanType is 'Employer', we need to change the first column header text to read 'Employer', if it's anything else then the header should read 'Health Plan'
		if (ptArray[0] === 'Employer') {
			mmit.updateFirstColumnName('Employer');
		} else {
			mmit.updateFirstColumnName('healthPlan');
		}
		mmit.mmit.dataArray = tempDataArray;
		return mmit.mmit.dataArray;
	},
	createDataTable: function(data){
		$.fn.dataTable.ext.errMode = 'none';
		var columnList = [
			{ data: 'planName', 'width': '53%' },
			{ data: 'universalStatusRollup', 'width': '43%'},
			{ data: 'lives', visible: false, 'width': '0%' },
			{ data: 'restrictionCodeDetail', visible: false, 'width': '0%' },
			{ data: 'restrictionCode', visible: false, 'width': '0%' },
			{
				"className":      'details-control',
				"orderable":      false,
				data:           null,
				"defaultContent": '',
				'width': '4%'
			}
		];

		mmit.mmit.dataTableObj = $(mmit.mmitTable).DataTable({
			scrollX: false,
			deferRender: true,
			select: {
				items: 'row',
				toggleable: true,
				style:     'single',
				className: 'row-selected'
			},
			"dom": 'firtp',
			scrollCollapse: true,
			paging: true,
			"lengthChange": false,
			"pageLength": 20,
			"pagingType": "simple_numbers",
			"language": {
				"paginate": {
					"next": "Next",
					"previous": "Previous"
				},
				"info": "Showing _START_ to _END_ of _TOTAL_ plans",
				"infoEmpty":      "Showing 0 to 0 of 0 plans"
			},
			"info": true,
			'search': {
				"smart": false,
				"caseInsensitive": true,
				"regex": true
			},
			'ordering': false,
			"autoWidth": false,
			"processing": true,
			"drawCallback": function () {
				// click event for paginate buttons if it's mobile, then scroll to top of list, otherwise nothing happens.
				$('a.paginate_button').on('click', function (){
					TweenMax.to(window, 1, {scrollTo:{y:".search-table", offsetY: 3}});
				});
			},
			data: data,
			columns: columnList,
			createdRow: function ( row, data, index ) {
				if (!data.restrictionCode) {
					var td = $(row).find("td:nth-child(3)");
					td.removeClass( 'details-control' );
				} else {
					var td = $(row).find("td:last");
					td.on('click', function(e){
						e.preventDefault();
						var tr = $(this).closest('tr');
						var row = mmit.mmit.dataTableObj.row(tr);

						if (row.child.isShown()){
							row.child.hide();
							tr.removeClass('shown');
						} else {
							if ( mmit.mmit.dataTableObj.row( '.shown' ).length ) {
								$('.details-control', mmit.mmit.dataTableObj.row( '.shown' ).node()).click();
							}
							var rowData = row.data();
							row.child(rowData.restrictionCodeDetail).show();
							row.child().addClass('childRow');
							var childtd = $(row.child()).find("td");
							childtd.prepend("<span class='bold'>Restrictions: </span>");
							tr.addClass('shown');
						}
					})
				}
			}
		}).on( 'error.dt', function ( e, settings, techNote, message ) {
			console.log( 'An error has been reported by DataTables: ', message );
		});
	},
	redrawTable: function(data){
		/*
		 Clear the current data from the table, add rows for the new data and then redraw the table
		 */
		mmit.mmit.dataTableObj.clear().rows.add(data).draw();
		// Show the table and the search function
		mmit.showTable();
	},
	hideTable: function(){
		mmit.mmitTableContainer.addClass('hidden');
		mmit.mmitSearchTable.addClass('hide-search');
		$('.search-table').prop('disabled', 'disabled');
		mmit.mmitFootnote.addClass('hidden');
		mmit.mmitBlocker.removeClass('hidden');
	},
	showTable: function(){
		mmit.mmitTableContainer.removeClass('hidden');
		mmit.mmitSearchTable.removeClass('hide-search');
		$('.search-table').prop('disabled', '');
		mmit.mmitFootnote.removeClass('hidden');
		mmit.mmitBlocker.addClass('hidden');
		TweenLite.to(window, 1, {scrollTo:{y:".mmit-data-form", offsetY: 80}});
	},
	updateFirstColumnName: function(planType){
		var newHeader = '';

		if (planType === 'Employer'){
			newHeader = planType;
		} else {
			newHeader = 'Formulary';
		}

		mmit.mmitFirstCol.html(newHeader);
	},
	returnPlanType: function (planName) {
		var planTypesArray = [];

		switch (planName){
			case ('both'):
				planTypesArray.push('Medicare');
				planTypesArray.push('Medicare MA-PD');
				planTypesArray.push('Medicare PDP');
				planTypesArray.push('Commercial');
				break;
			case ('commercial'):
				planTypesArray.push('Commercial');
				break;
			case ('medicare'):
				planTypesArray.push('Medicare');
				planTypesArray.push('Medicare MA-PD');
				planTypesArray.push('Medicare PDP');
				break;
			case ('employer'):
				planTypesArray.push('Employer');
				break;
			default:
				console.log('hitting default, theres an issue');
				break;
		}
		return planTypesArray;
	},

	allStates: {
		AL: "Alabama",
		AK: "Alaska",
		AZ: "Arizona",
		AR: "Arkansas",
		CA: "California",
		CO: "Colorado",
		CT: "Connecticut",
		DE: "Delaware",
		DC: "District Of Columbia",
		FL: "Florida",
		GA: "Georgia",
		HI: "Hawaii",
		ID: "Idaho",
		IL: "Illinois",
		IN: "Indiana",
		IA: "Iowa",
		KS: "Kansas",
		KY: "Kentucky",
		LA: "Louisiana",
		ME: "Maine",
		MD: "Maryland",
		MA: "Massachusetts",
		MI: "Michigan",
		MN: "Minnesota",
		MS: "Mississippi",
		MO: "Missouri",
		MT: "Montana",
		NE: "Nebraska",
		NV: "Nevada",
		NH: "New Hampshire",
		NJ: "New Jersey",
		NM: "New Mexico",
		NY: "New York",
		NC: "North Carolina",
		ND: "North Dakota",
		OH: "Ohio",
		OK: "Oklahoma",
		OR: "Oregon",
		PA: "Pennsylvania",
		RI: "Rhode Island",
		SC: "South Carolina",
		SD: "South Dakota",
		TN: "Tennessee",
		TX: "Texas",
		UT: "Utah",
		VT: "Vermont",
		VA: "Virginia",
		WA: "Washington",
		WV: "West Virginia",
		WI: "Wisconsin",
		WY: "Wyoming"
	},
	buildStateSelector: function () {
		var stateKeys = Object.getOwnPropertyNames(mmit.allStates);
		var selectorData = '';
		for (var i = 0; i < stateKeys.length; i++){
			selectorData += '<option value="' + stateKeys[i] + '">' + mmit.allStates[stateKeys[i]]+ '</option>';
		}
		mmit.mmitStateSelector.append(selectorData);
	},
	buildRegionSelector: function(){
		var regionKeys = mmit.mmit.dataObject['Regions'];
		var selectorData = '';
		for (var region in regionKeys) {
			selectorData += '<option value="'+region+'">'+regionKeys[region]+'</option>';
		}
		mmit.mmitRegionSelector.append(selectorData);
	}
}
